import React, { useEffect, useMemo, useState } from 'react';
import useForm from '@utils/useForm';
import { Helpers } from '@utils/helpers';
import { GAAviva } from '@utils/gaAviva';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { useAvivaSelector, useAvivaDispatch } from '@redux/hook';
import { useHistory } from 'react-router-dom';
import { isEmpty, get } from 'lodash';
import { setLoadingState } from '@redux/slices/loadingSlice'
import { ContactForm } from '@models/MLTC/Contact.model';
import { postContactCIMBMltc, postContactMltc } from '@api/index';

import { LeftGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import RadioButtonGroup from '@components/RadioButtonGroup';
import RadioButton from '@components/RadioButton';
import Heading from '@components/Heading';
import Dropdown from '@components/Dropdown';
import Input from '@components/Input';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Button from '@components/Button';
import Bullet from '@components/Bullet';
import Segment from '@components/Segment';
import Link from '@components/Link';
import { validate } from './service';
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';

const page = 'Contact';

const fluidBox = css`
  margin-top: -40px!important;
`;

const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form, acquisition } = GA.digitalData;
  form.name = 'Contact';
  GA.trackPageLoad({ form, acquisition });
}

const trackFormSubmmit = (error: string = ''): void => {
  const GA = GAAviva.getInstance();
  if (isEmpty(error)) {
    GA.trackFormSuccess({});
    return;
  }
  const { form } = GA.digitalData;
  form.error.messages = error;
  GA.trackFormFailed({ form });
}
export interface ContactProps { }

const createContactRequest = (
  form: ContactForm,
  isVulnerable: boolean | undefined,
  transactionId: number,
  isRental: boolean | undefined,
  campaignCode: string | undefined,
  productName: string | undefined) => {
  const content = {
    email: form.emailId,
    fname: form.surname,
    lname: form.givname,
    title: Helpers.getSalutationByCode(form.salutation || ''),
    dateOfBirth: form.dob,
    phone_number: form.mobileNum && `+65${form.mobileNum}`,
    pdpaDetails: "{}",
    selectedPlan: productName,
    VulnerableCustomer: isVulnerable ? 'true' : 'false',
    RentalPostalCustomer: isRental ? 'true' : 'false',
    referrerDetails: `${window.location.origin}/api/contactUs?cc=${campaignCode ? campaignCode : 'MLO1'}`,
    nationalIdentifier: form.nric
  }

  return {
    transactionId,
    // campaignCode: campaignCode,
    content: JSON.stringify(content),
    cc: campaignCode ? campaignCode : 'MLO1'
  }
}

function Contact(props: ContactProps) {
  console.log(`QnB ➤ PAGE ➤ Aviva - ${page}`);
  const history = useHistory();
  const website = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
  const dispatch = useAvivaDispatch(); const theme: ITheme = useTheme();
  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const salutations = useAvivaSelector(state => state.staticData.salutations);
  const basicDetails = useAvivaSelector(state => state.mltcStep1.basicDetails);
  const quoteRawResponse = useAvivaSelector(state => state.mltcStep1.quoteRawResponse);
  const myInfoForm = useAvivaSelector(state => state.mltcStep2.myInfoForm);
  const retrievedMyInfo = useAvivaSelector(state => state.mltcStep2.retrievedMyInfo);
  const hasMyInfo = useAvivaSelector(state => state.mltcStep2.hasMyInfo);
  const [isVulnerable, setIsVulnerable] = useState<boolean | undefined>(undefined);
  const [isRental, setIsRental] = useState<boolean | undefined>(undefined);
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const [isSubmited, setIsSubmitted] = useState<boolean>(false);
  const [campaignCode, setCampaignCode] = useState<string>('MLO1');

  const urlParams = Helpers.getURLSearchParams();

  const onBack = () => {
    history.goBack();
  }

  const { values, errors, patchValue, handleChange, formValid } = useForm(new ContactForm(myInfoForm), () => { }, validate);

  const getTimestamp = () => {
    const pad = (i: string | number) => { return (i < 10) ? '0' + i : i; };

    const d = new Date();
    const Y = d.getFullYear();
    const m = d.getMonth() + 1;
    const D = d.getDate();
    const H = d.getHours();
    const M = d.getMinutes();
    const S = d.getSeconds();
    const ms = ('00' + d.getMilliseconds()).slice(-3);
    return `` + Y + pad(m) + pad(D) + pad(H) + pad(M) + pad(S) + ms;
  }

  const onSubmit = async () => {
    dispatch(setLoadingState(true));
    let transactionId = retrievedMyInfo?.id || Number(getTimestamp());
    console.log({ transactionId });

    let productName = 'Singlife CareShield Standard';
    if (quoteRawResponse) {
      const planQuotation = new SQSPocketResponse(quoteRawResponse);
      productName = planQuotation.planName || 'Singlife CareShield Standard';
    }
    const payload: any = createContactRequest(values, isVulnerable, transactionId, isRental, campaignDetail?.campaignCode, productName);
    

    if (campaignDetail?.code === 'LCB1') {
      let planName = 'Singlife CareShield Standard';
      if (quoteRawResponse) {
        const planQuotation = new SQSPocketResponse(quoteRawResponse);
        console.log('plan name', planQuotation.planName);
        planName = planQuotation.planName || '';
      }
      const request = {
        "templateCode": isRental ? 'rental_property' : (isVulnerable ? 'trusted_individual' : 'generic'),
        "productName": planName,
        "excelData": {
          "salutation": values['salutation'],
          "givenName": values['givname'],
          "familyName": values['surname'],
          "mobileNumber": values['mobileNum'],
          "email": values['emailId']
        }
      }
      try {
        const response = await postContactCIMBMltc(request);
        console.debug(response);
        setIsSubmitted(true);
        trackFormSubmmit();
        Helpers.clearCached();
        dispatch(setLoadingState(false));

      } catch (error) {
        trackFormSubmmit(get(error, 'message'));
        console.error(error);
        dispatch(setLoadingState(false));
      }

    } else {
      try {
        const response = await postContactMltc(payload);
        console.debug(response);
        setIsSubmitted(true);
        trackFormSubmmit();
        Helpers.clearCached();
        dispatch(setLoadingState(false));

      } catch (error) {
        trackFormSubmmit(get(error, 'message'));
        console.error(error);
        dispatch(setLoadingState(false));
      }
    }
  }

  const blurDropdown = (e: any) => {
    // console.log('blurDropdown', { e, type: typeof e });
    if (typeof e === 'undefined') {
      patchValue({ salutation: ''});
    }
  }


  const invalidForm: boolean = useMemo(() => {
    // console.log('invalidForm', {
    //   forminvalid: !formValid, noMyInfo: !hasMyInfo,
    //   isAvivaCustomerNotNull: values['isAvivaCustomer'] === undefined && campaignCode === 'MLO1'
    // });

    return !formValid || (!hasMyInfo && (values['isAvivaCustomer'] === undefined && campaignCode === 'MLO1'))
  }, [formValid, hasMyInfo, values, campaignCode]);

  useEffect(() => {
    if (!isPageLoaded) {
      console.log('QnB ➤ Contact ➤ useEffect() ➤ Parent', { campaignDetail });
      trackOnload();
      // Retrieve campaign code from url
      const urlCC = urlParams.get('cc');
      const dataIsLoaded = !!urlCC && !!campaignDetail || !urlCC;

      if (campaignDetail) {
        setCampaignCode(campaignDetail?.code);
        if (campaignDetail?.code === 'LCB1') {
          patchValue({
            isAvivaCustomer: 'N'
          });

          if (quoteRawResponse) {
            const planQuotation = new SQSPocketResponse(quoteRawResponse);
            console.log('plan name', planQuotation.planName);
          }
        }
      }

      if (basicDetails) {
        patchValue({
          dob: Helpers.parseDobString(basicDetails.dob)
        })
      }
      if (isVulnerable === undefined) {
        const vulnerable = urlParams.get('vulnerable');
        setIsVulnerable(vulnerable === 'true');
      }
      if (isRental === undefined) {
        const rental = urlParams.get('rental');
        setIsRental(rental === 'true');
      }

      if (dataIsLoaded) setIsPageLoaded(true);
    }
  }, [hasMyInfo, patchValue, setCampaignCode, isPageLoaded, urlParams, basicDetails, isRental, isVulnerable, campaignDetail]);
  // console.log(values);

  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 20px" paddingTablet="80px 0 80px 30px">
        <ContainerGrid>
          <LeftGrid>
            {!isSubmited ? (
              <React.Fragment>
                <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for your interest in this plan. </Heading>
                {retrievedMyInfo ? (
                  <Heading variant="label" color={theme.colors.white} margin="0 0 10px" fontWeight={300}>
                    {campaignDetail?.code !== 'LCB1' && (
                      <>
                        We are unable to proceed with your application at the moment.
                        Please fill up the below form and we’ll appoint a financial adviser representative to contact you.
                        The representative will conduct financial needs analysis and recommend suitable products to meet your insurance needs.
                      </>
                    )}
                    {campaignDetail?.code === 'LCB1' && (
                      <>
                        We are unable to complete your application now.
                        Please fill up the below form and our appointed intermediary (CIMB Bank Berhad, Singapore Branch) Specialist will contact you
                        to conduct financial needs analysis and advise suitable products to meet your insurance needs.
                      </>
                    )}
                  </Heading>
                ) : (
                  <Heading variant="label" color={theme.colors.white} margin="0 0 10px" fontWeight={300}>
                    {campaignDetail?.code !== 'LCB1' && (
                      <>
                        We are unable to proceed with your application at the moment.
                        Please fill up the below form and we’ll appoint a financial adviser representative to contact you.
                        The representative will conduct financial needs analysis and recommend suitable products to meet your insurance needs.
                      </>
                    )}
                    {campaignDetail?.code === 'LCB1' && (
                      <>
                        We are unable to complete your application now.
                        Please fill up the below form and our appointed intermediary (CIMB Bank Berhad, Singapore Branch) Specialist will contact you
                        to conduct financial needs analysis and advise suitable products to meet your insurance needs.
                      </>
                    )}
                  </Heading>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {campaignDetail?.code !== 'LCB1' && (<>
                  <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for your submission. </Heading>
                  <Heading variant="label" color={theme.colors.white} fontWeight={300}>
                    Our financial adviser representative will be in touch with you shortly.
                    Please visit our <Link color={theme.colors.white} fontSize={theme.fontSize.label} fontSizeTablet={theme.fontSize.label} target="_blank" rel="noopener noreferrer" url={website} text="website"></Link> for other insurance solutions.
                  </Heading>
                </>)}
                {campaignDetail?.code === 'LCB1' && (<>
                  <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for submitting the enquiry form. </Heading>
                  <Heading variant="label" color={theme.colors.white} fontWeight={300}>
                    A representative from CIMB Bank will be in touch with you within 1 working day. For other insurance solutions, you may visit CIMB Bank&apos;s website&nbsp;
                    <Link color={theme.colors.white} fontSize={theme.fontSize.label} fontSizeTablet={theme.fontSize.label} target="_blank" rel="noopener noreferrer" url={'https://www.cimb.com.sg/en/personal/banking-with-us/insurance/protection.html'} text="here"></Link>.
                  </Heading>
                </>)}

                <style>
                  {`footer {
                      position: fixed;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    }`}
                </style>
              </React.Fragment>
            )}

          </LeftGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        {!isSubmited && (<LeftGrid>
          <Heading variant="label">Salutation</Heading>
          {!errors?.salutation?.isValid && errors?.salutation?.message && (<Bullet variant="error">{errors?.salutation?.message}</Bullet>)}
          <Dropdown source={Helpers.filterSalutations(basicDetails?.gender || '', salutations, '')} bindId="code" bindLabel="description" name="salutation" value={values['salutation']} onChange={handleChange} onBlur={blurDropdown} placeholder="Please select" />
          <Heading variant="label">Given name</Heading>
          {!errors?.givname?.isValid && errors?.givname?.message && (<Bullet variant="error">{errors?.givname?.message}</Bullet>)}
          <Input name="givname" value={values['givname']} invalid={!isEmpty(errors?.givname?.message)} type="alphanumeric" maxLength={40} onChange={handleChange} />
          <Heading variant="label" >Family name</Heading>
          {!errors?.surname?.isValid && errors?.surname?.message && (<Bullet variant="error">{errors?.surname?.message}</Bullet>)}
          <Input name="surname" value={values['surname']} invalid={!isEmpty(errors?.surname?.message)} type="alphanumeric" maxLength={40} onChange={handleChange} />
          <Heading variant="label">Mobile number</Heading>
          {!errors?.mobileNum?.isValid && errors?.mobileNum?.message && (<Bullet variant="error">{errors?.mobileNum?.message}</Bullet>)}
          <Input type="numeric" variant="prefix" boxLabel="+65" invalid={!isEmpty(errors?.mobileNum?.message)} maxLength={8} name="mobileNum" value={values['mobileNum']} onChange={handleChange} />
          <Heading variant="label">Email address</Heading>
          {!errors?.emailId?.isValid && errors?.emailId?.message && (<Bullet variant="error">{errors?.emailId?.message}</Bullet>)}
          <Input name="emailId" value={values['emailId']} invalid={!isEmpty(errors?.emailId?.message)} maxLength={50} onChange={handleChange} />
          {(!hasMyInfo && (campaignCode === 'MLO1' && !campaignDetail?.code)) && (
            <><Heading variant="label">Are you an existing Singlife customer?</Heading>
              <RadioButtonGroup value={values['isAvivaCustomer']} name="isAvivaCustomer" onChange={handleChange} margin={`0 0 ${values['isAvivaCustomer'] === 'Y' ? '15px' : '40px'}`}>
                <RadioButton value="Y" text="Yes"></RadioButton>
                <RadioButton value="N" text="No"></RadioButton>
              </RadioButtonGroup></>
          )}
          {values['isAvivaCustomer'] === 'Y' && (
            <Segment hasBorderTop={true}>
              <Heading margin="0 0 15px" variant="label">NRIC (last 4 characters e.g. 123A)</Heading>
              {!errors?.nric?.isValid && errors?.ninricrc?.message && (<Bullet variant="error">{errors?.nric?.message}</Bullet>)}
              <Input name="nric" value={values['nric']} maxLength={4} invalid={!isEmpty(errors?.nric?.message)} onChange={handleChange} margin={0} />
            </Segment>
          )}
          <ContainerBlock padding={20} paddingTablet={20} margin="40px 0 40px 0" background={theme.colors.grey[600]}>
            {campaignDetail?.code !== 'LCB1' && (
              <Text>
                By clicking “Submit”, you consent to Singapore Life Ltd. (“Singlife”) and Singlife related group of companies contacting you to provide you with information concerning
                Singlife and Singlife related group of companies’ products and services.
                You also consent to Singlife using, disclosing or transferring your personal data in this form to Singlife related group of companies,
                third party providers or intermediaries, whether located in Singapore or elsewhere,
                for the above purposes and for research, audit, regulatory and compliance purposes.
              </Text>
            )}
            {campaignDetail?.code === 'LCB1' && (
              <>
                <Text>
                  By clicking “Submit”, you consent to Singapore Life Ltd. (“Singlife”) and appointed intermediary (CIMB Bank Berhad, Singapore Branch) contacting you via call,
                  SMS, email or mail to provide you with information concerning Singlife&apos;s products and services.
                </Text>
                <Text margin={'20px 0 0'}>
                  You also consent to Singlife using, disclosing or transferring your personal data in this form to our appointed intermediary (CIMB Bank Berhad, Singapore Branch)
                  for the above purpose.
                </Text>
              </>
            )}
          </ContainerBlock>
          <Button label="Submit" disabled={invalidForm} margin="0 0 20px" onClick={onSubmit} />
          <Button variant="secondary" label="Back" margin="0 0 40px" onClick={onBack} />
        </LeftGrid>)}
      </ContainerGrid>

    </Container>
  );
};

export default Contact;
